import React from 'react';
import useProgressiveImage from '../../hooks/ProgressiveImage';
import { CoverImage, ImageContainer, CoverImageSource } from './BackgroundImageContainer.Styled';
import { BackgroundImageContainerPropTypes, BackgroundImageContainerDefaultProps } from './types/BackgroundImageContainer.prop-types';
export const BackgroundImageContainer = ({ src, fallbackSrc, children, webpSrc }) => {
    const srcImage = useProgressiveImage({ src, fallbackSrc });
    return (React.createElement(ImageContainer, null,
        React.createElement("picture", null,
            React.createElement(CoverImageSource, { srcSet: webpSrc, type: 'image/webp' }),
            React.createElement(CoverImage, { src: srcImage })),
        children));
};
BackgroundImageContainer.propTypes = BackgroundImageContainerPropTypes;
BackgroundImageContainer.defaultProps = BackgroundImageContainerDefaultProps;
//# sourceMappingURL=BackgroundImageContainer.js.map